import { CUSTOM_SCHEME_PATH, MethodUrlLike } from 'services/api-constants';
import { downloadPdf, methodDownloadPdfPage, pdfDownloadErrorMessage } from 'utils/market-pdf';
import useRemove from './useRemove';
import { useSwitchProfile } from './useSwitchProfile';
import useUser from './useUser';

/** Use handle method hook */
const useHandleMethod = () => {
  const { onLogout, user } = useUser();
  const onSwitchProfile = useSwitchProfile();
  const onRemove = useRemove();

  const handleMethod = async (
    urlEntity: URL | MethodUrlLike,
    setIsLoading: (value: boolean) => void,
    setErrorMessage: (value: string) => void,
    onRefresh?: () => void,
  ) => {
    if (urlEntity.pathname.startsWith(CUSTOM_SCHEME_PATH.Logout)) {
      await onLogout();
    } else if (urlEntity.pathname.startsWith(CUSTOM_SCHEME_PATH.SwitchProfile)) {
      const selectedId = urlEntity.searchParams.get('id') || '';
      if (user?.profileId?.toString() === selectedId.toString()) {
        return;
      }
      setIsLoading(true);
      const error = await onSwitchProfile(selectedId);
      if (error) {
        setErrorMessage(error.message);
        setIsLoading(false);
        return;
      }
      window.location.reload();
    } else if (urlEntity.pathname.startsWith(CUSTOM_SCHEME_PATH.Remove)) {
      setIsLoading(true);
      const error = await onRemove(urlEntity.href);
      if (error) {
        setErrorMessage(error.message);
        setIsLoading(false);
        return;
      }
      if (onRefresh) onRefresh();
      return;
    } else if (urlEntity.pathname.startsWith(CUSTOM_SCHEME_PATH.Download)) {
      setIsLoading(true);

      const page = methodDownloadPdfPage(urlEntity.href, {
        outerName: urlEntity.searchParams.get('name'),
      });

      try {
        await downloadPdf(page);
      } catch (error) {
        setErrorMessage(pdfDownloadErrorMessage(error));
      } finally {
        setIsLoading(false);
      }
    }
  };

  return handleMethod;
};

export default useHandleMethod;
